import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, queryPut } from '@/utils';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery,
  endpoints: (builder) => ({
    setPassword: builder.mutation({
      query: ({ userId, body }) => queryPut(`/users/${userId}/actions/set-password`, body),
    }),
  }),
});

export const { useSetPasswordMutation } = usersApi;
